import React from 'react';
import { Link} from "react-router-dom";
import learnmore from "../../assets/images/learn-more.svg";


const Banner = () => {
  return (  
    <div className="banner">
      <div className="banner-img">
        <div className="safe-travels">
          <div className="text">
            <h1 className="text-primary mb-4 fs-50 font-weight-normal">Safe Travels</h1>
            <p className="fs-15">SmartDrive protects and progresses fleet performance with<br></br> unparalleled safety programs. By combining analytics with<br></br> transportation intelligence SmartDrive unlocks opportunities<br></br> to drive efficiently and safely.</p>
          </div>
          <div className="learn-more">
            <div className="media fs-15">
              <img src={learnmore} className="mr-2 mt-2" alt="Learn More" />
              <div className="media-body">
                <Link to="/" className="text-black font-weight-bold">Learn more</Link>
              </div>
            </div>
          </div>
        </div>
      </div>      
    </div>    
  );
}
 
export default Banner;